class StoreAnalytics {
  constructor() {
    this.productEl = document.querySelector('[data-product-id]');
    this.cartTotalEl = document.querySelector('[data-cart-total]');
    document.addEventListener('DOMContentLoaded', () => this.init());
  }

  init() {
    this.trackProductView();
    this.trackAddToCart();
    this.trackBeginCheckout();
    this.trackCrossSellClicks();
    this.trackUrgencyBadge();
  }

  getProductData(el) {
    if (!el) return null;
    return {
      id: el.getAttribute('data-product-id'),
      name: el.getAttribute('data-product-name'),
      price: el.getAttribute('data-product-price')
    };
  }

  trackProductView() {
    const data = this.getProductData(this.productEl);
    if (!data || !data.id) return;
    this.sendEvent('view_item', {
      item_id: data.id,
      item_name: data.name,
      price: data.price
    });
  }

  trackAddToCart() {
    document.querySelectorAll('[name="add"], .add-to-cart, [data-add-to-cart]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        const product = event.target.closest('[data-product-id]');
        const data = this.getProductData(product);
        if (!data || !data.id) return;
        this.sendEvent('add_to_cart', {
          item_id: data.id,
          item_name: data.name,
          price: data.price
        });
      });
    });
  }

  trackBeginCheckout() {
    document.querySelectorAll('a[href*="/checkout"], [data-checkout], button[name="checkout"]').forEach((node) => {
      node.addEventListener('click', () => {
        this.sendEvent('begin_checkout', {
          value: this.getCartValue(),
          currency: 'EUR'
        });
      });
    });
  }

  trackCrossSellClicks() {
    document.querySelectorAll('.complete-the-kit-section a[data-product-id], .cart-recommendations__item a[data-product-id]').forEach((link) => {
      link.addEventListener('click', () => {
        const id = link.getAttribute('data-product-id');
        this.sendEvent('select_promotion', {
          promotion_id: 'cross_sell',
          items: [{ item_id: id }]
        });
      });
    });
  }

  trackUrgencyBadge() {
    const badge = document.querySelector('.urgency-badge');
    if (badge) {
      this.sendEvent('view_promotion', {
        promotion_id: 'urgency_badge',
        creative_name: 'low_stock'
      });
    }
  }

  getCartValue() {
    if (!this.cartTotalEl) return 0;
    return parseFloat(this.cartTotalEl.getAttribute('data-cart-total') || '0') || 0;
  }

  sendEvent(name, params) {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', name, params);
    }
    console.log('GA4 event', name, params);
  }
}

new StoreAnalytics();
